import { useMultiSelectFilter } from '@/domain/prices/filters/hooks';
import type { Option } from '@/domain/prices/filters/types';
import type { NestedOption } from '@/react-pages/Prices/Filters/GroupedAirportFilter/types';

export function useGroupedAirportFilter() {
  const { options, selectedValues, setSelection } = useMultiSelectFilter('DepartureAirport');

  const mapOptions = (originalOptions: Option[]): NestedOption[] => {
    const groups = new Set(originalOptions.map((option) => option.groupInfo));
    const mappedOptions = Array.from(groups).map((group) => {
      const children = originalOptions.filter((option) => option.groupInfo === group);
      return {
        id: group,
        value: group,
        selected: false,
        children: children.map((child) => ({
          id: child.value,
          value: child.name,
          trailing: child.value,
        })),
      } as NestedOption;
    });

    return mappedOptions;
  };

  return {
    options: mapOptions(options),
    selectedValues,
    setSelection,
  };
}
